var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLandingInstagramLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2143 0H5.78571C2.59035 0 0 2.59035 0 5.78571V21.2143C0 24.4096 2.59035 27 5.78571 27H21.2143C24.4096 27 27 24.4096 27 21.2143V5.78571C27 2.59035 24.4096 0 21.2143 0Z",
    fill: "url(#paint0_radial_9332_440)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2143 0H5.78571C2.59035 0 0 2.59035 0 5.78571V21.2143C0 24.4096 2.59035 27 5.78571 27H21.2143C24.4096 27 27 24.4096 27 21.2143V5.78571C27 2.59035 24.4096 0 21.2143 0Z",
    fill: "url(#paint1_radial_9332_440)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2143 0H5.78571C2.59035 0 0 2.59035 0 5.78571V21.2143C0 24.4096 2.59035 27 5.78571 27H21.2143C24.4096 27 27 24.4096 27 21.2143V5.78571C27 2.59035 24.4096 0 21.2143 0Z",
    fill: "url(#paint2_radial_9332_440)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2503 8.19643C20.2503 8.99524 19.6027 9.64286 18.8039 9.64286C18.005 9.64286 17.3574 8.99524 17.3574 8.19643C17.3574 7.39759 18.005 6.75 18.8039 6.75C19.6027 6.75 20.2503 7.39759 20.2503 8.19643Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5001 18.3206C16.1629 18.3206 18.3216 16.1619 18.3216 13.4992C18.3216 10.8364 16.1629 8.67773 13.5001 8.67773C10.8374 8.67773 8.67871 10.8364 8.67871 13.4992C8.67871 16.1619 10.8374 18.3206 13.5001 18.3206ZM13.5001 16.392C15.0979 16.392 16.393 15.0969 16.393 13.4992C16.393 11.9014 15.0979 10.6063 13.5001 10.6063C11.9024 10.6063 10.6073 11.9014 10.6073 13.4992C10.6073 15.0969 11.9024 16.392 13.5001 16.392Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.85742 13.1155C3.85742 9.87525 3.85742 8.25506 4.48803 7.01746C5.04272 5.9288 5.92782 5.0437 7.01648 4.489C8.25408 3.8584 9.87427 3.8584 13.1146 3.8584H13.886C17.1263 3.8584 18.7465 3.8584 19.984 4.489C21.0727 5.0437 21.9578 5.9288 22.5125 7.01746C23.1431 8.25506 23.1431 9.87525 23.1431 13.1155V13.887C23.1431 17.1273 23.1431 18.7474 22.5125 19.985C21.9578 21.0737 21.0727 21.9588 19.984 22.5135C18.7465 23.1441 17.1263 23.1441 13.886 23.1441H13.1146C9.87427 23.1441 8.25408 23.1441 7.01648 22.5135C5.92782 21.9588 5.04272 21.0737 4.48803 19.985C3.85742 18.7474 3.85742 17.1273 3.85742 13.887V13.1155ZM13.1146 5.78697H13.886C15.538 5.78697 16.6609 5.78847 17.529 5.85939C18.3745 5.92847 18.8069 6.05368 19.1086 6.20737C19.8343 6.57717 20.4243 7.16724 20.7941 7.89297C20.9478 8.1946 21.0731 8.62698 21.1421 9.47257C21.213 10.3406 21.2146 11.4635 21.2146 13.1155V13.887C21.2146 15.539 21.213 16.6619 21.1421 17.5299C21.0731 18.3755 20.9478 18.8079 20.7941 19.1095C20.4243 19.8353 19.8343 20.4253 19.1086 20.7951C18.8069 20.9488 18.3745 21.0741 17.529 21.1431C16.6609 21.214 15.538 21.2155 13.886 21.2155H13.1146C11.4625 21.2155 10.3396 21.214 9.47159 21.1431C8.62601 21.0741 8.19362 20.9488 7.89199 20.7951C7.16626 20.4253 6.5762 19.8353 6.20639 19.1095C6.05271 18.8079 5.92749 18.3755 5.85841 17.5299C5.7875 16.6619 5.78599 15.539 5.78599 13.887V13.1155C5.78599 11.4635 5.7875 10.3406 5.85841 9.47257C5.92749 8.62698 6.05271 8.1946 6.20639 7.89297C6.5762 7.16724 7.16626 6.57717 7.89199 6.20737C8.19362 6.05368 8.62601 5.92847 9.47159 5.85939C10.3396 5.78847 11.4625 5.78697 13.1146 5.78697Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_9332_440",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.64286 20.25) rotate(-55.3758) scale(24.6082)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B13589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79309,
    stopColor: "#C62F94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A3AC8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_9332_440",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.67857 27.9643) rotate(-65.1363) scale(21.7873)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E8B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444662,
    stopColor: "#FB8A2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71474,
    stopColor: "#E2425C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2425C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_9332_440",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-1.44643 0.964286) rotate(-8.1301) scale(37.5019 8.02128)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.156701,
    stopColor: "#406ADC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467799,
    stopColor: "#6A45BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A45BE",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingInstagramLogo);
export default __webpack_public_path__ + "static/media/landing-instagram-logo.905f58c6d9404ba27d1fa3494373c270.svg";
export { ForwardRef as ReactComponent };